export enum DepartmentRole {
    Indeterminate = 0,
    RoleRescinded = 1,
    Attendant = 2,
    Keyman = 3,
    AdministrativeAssistant = 4,
    AssistantOverseer = 5,
    DepartmentOverseer = 6,
    GlobalAdministrator = 7,
}

